import tw from 'twin.macro'

export const TableCell = tw.td`
  px-6 py-4 whitespace-nowrap 
`
